import { validaCPF } from '@/shared/utils/cpfs';
import { EstadosCivisList } from '@/modules/people/enums/estado-civil.enum';
import type { ReadCandidatoDto, ReadPersonDto } from '@/api.types';

const SITUACAO_LABELS: Record<string, string> = {
  rascunho: 'Rascunho',
  inscricao_realizada: 'Inscrição Realizada',
  inscricao_validada: 'Inscrição Validada',
  indeferida: 'Indeferida',
  classificada: 'Classificada',
  convocada: 'Convocada',
};

const RACAS_LABELS: Record<string, string> = {
  branca: 'Branca',
  preta: 'Preta',
  parda: 'Parda',
  amarela: 'Amarela',
  indigena: 'Indígena',
};

export function formatarSituacaoCandidato(situacao: string): string {
  return SITUACAO_LABELS[situacao] ?? situacao;
}

export function formatarGeneroCandidato(genero: string): string {
  return genero === 'masculino' ? 'Masculino' : genero === 'feminino' ? 'Feminino' : genero;
}

export function formatarRacaCandidato(raca: string): string {
  return RACAS_LABELS[raca] ?? raca;
}

export function formatarCpfExibicao(cpf: string | undefined): string {
  return cpf ? validaCPF(cpf, true) : '-';
}

export function formatarEstadoCivilExibicao(estadocivil: number | undefined | null): string {
  if (typeof estadocivil !== 'number') return '-';
  const found = EstadosCivisList.find((item) => item.value === estadocivil);
  return found?.name ?? '-';
}

export function formatarContatoCandidato(candidato: ReadCandidatoDto): string {
  if (candidato.pessoaTelefone && candidato.pessoaTelefone.trim() !== '') {
    return candidato.pessoaTelefone;
  }

  if (candidato.celular?.ddd && candidato.celular?.numero) {
    return `(${candidato.celular.ddd}) ${candidato.celular.numero}`;
  }

  if (candidato.telefone?.ddd && candidato.telefone?.numero) {
    return `(${candidato.telefone.ddd}) ${candidato.telefone.numero}`;
  }

  return '-';
}

export function getEnderecoExibicao(candidato: ReadCandidatoDto, pessoa: ReadPersonDto | null) {
  return candidato.endereco ?? pessoa?.endereco ?? null;
}

